import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const ErrorIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <path
        className={`icon--${props.color}`}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.224C6.06 1.224 1.224 6.06 1.224 12C1.224 17.94 6.06 22.776 12 22.776C17.94 22.776 22.776 17.94 22.776 12C22.776 6.06 17.94 1.224 12 1.224ZM12 21.372C6.828 21.372 2.628 17.172 2.628 12C2.628 6.828 6.828 2.628 12 2.628C17.172 2.628 21.372 6.828 21.372 12C21.372 17.172 17.172 21.372 12 21.372ZM12 15.096C12.384 15.096 12.696 14.784 12.696 14.4V6.50397C12.696 6.11997 12.384 5.80797 12 5.80797C11.616 5.80797 11.304 6.11997 11.304 6.50397V14.4C11.304 14.784 11.616 15.096 12 15.096ZM12.924 17.2801C12.924 17.7904 12.5103 18.2041 12 18.2041C11.4897 18.2041 11.076 17.7904 11.076 17.2801C11.076 16.7698 11.4897 16.3561 12 16.3561C12.5103 16.3561 12.924 16.7698 12.924 17.2801Z"
      />
    </IconSvgWrapper>
  );
};

export default ErrorIcon;
